module.exports = __webpack_public_path__ + "static/media/55_000005.38ccc231.jpg";